module.exports = __webpack_public_path__ + "dist/media/ec_comp_hero_banner.c2b833de.svg";